import styles from "./LThreeCols.module.css";

/**
 * LThreeCols — page layout 3-kolumnowy: lewy sidebar + główny obszar + prawy sidebar.
 *
 * Klasyczny portal layout: nawigacja po lewej, content w środku, related/social
 * po prawej. Środkowa kolumna zwykle największa.
 */
export function LThreeCols({ leftSidebar, main, rightSidebar }: LThreeColsProps) {
  return (
    <div className={styles.root}>
      <aside className={styles.leftSidebar}>{leftSidebar}</aside>
      <div className={styles.main}>{main}</div>
      <aside className={styles.rightSidebar}>{rightSidebar}</aside>
    </div>
  );
}

export type LThreeColsProps = {
  leftSidebar: React.ReactNode;
  main: React.ReactNode;
  rightSidebar: React.ReactNode;
};
